import { FiSearch } from "react-icons/fi";

export default function LeaveFilters({
  search,
  setSearch,
  leaveType,
  setLeaveType,
  status,
  setStatus,
  leaveTypes = [],
}) {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
      <div className="flex flex-col lg:flex-row gap-4">

        {/* Search */}
        <div className="relative flex-1">
          <FiSearch
            className="
              absolute
              left-4
              top-1/2
              -translate-y-1/2
              text-gray-400
            "
          />

          <input
            type="text"
            placeholder="Search employee..."
            value={search}
            onChange={(e) =>
              setSearch(e.target.value)
            }
            className="
              w-full
              pl-11
              pr-4
              py-3
              rounded-xl
              border
              border-gray-200
              focus:outline-none
              focus:ring-2
              focus:ring-red-800
            "
          />
        </div>

        {/* Leave Type */}
        <select
          value={leaveType}
          onChange={(e) =>
            setLeaveType(e.target.value)
          }
          className="
            px-4
            py-3
            rounded-xl
            border
            border-gray-200
            focus:outline-none
            focus:ring-2
            focus:ring-red-800
          "
        >
          <option value="All">
            All Leave Types
          </option>

          {leaveTypes.map(type => <option key={type.id} value={type.id}>{type.name}</option>)}
        </select>

        {/* Status */}
        <select
          value={status}
          onChange={(e) =>
            setStatus(e.target.value)
          }
          className="
            px-4
            py-3
            rounded-xl
            border
            border-gray-200
            focus:outline-none
            focus:ring-2
            focus:ring-red-800
          "
        >
          <option value="All">
            All Statuses
          </option>

          <option value="Pending">
            Pending
          </option>

          <option value="Approved">
            Approved
          </option>

          <option value="Rejected">
            Rejected
          </option>
        </select>

      </div>
    </div>
  );
}
